module.exports = __webpack_public_path__ + "img/landing2.de3c4d15.png";